import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../../controls/displayNames';
var PanelFooter = /*#__PURE__*/function (_React$Component) {
  function PanelFooter() {
    _classCallCheck(this, PanelFooter);
    return _callSuper(this, PanelFooter, arguments);
  }
  _inherits(PanelFooter, _React$Component);
  return _createClass(PanelFooter, [{
    key: "render",
    value: function render() {
      var ActionBtnSymbol = this.props.actionBtnSymbol;
      var Thumbnails = this.props.thumbnails;
      return /*#__PURE__*/React.createElement("footer", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('panel-footer'),
        style: this.props.style
      }, ActionBtnSymbol ? /*#__PURE__*/React.createElement(ActionBtnSymbol, null) : null, /*#__PURE__*/React.createElement("div", {
        className: "panel-footer-action-btn"
      }, this.props.actionBtn), Thumbnails ? /*#__PURE__*/React.createElement(Thumbnails, null) : null);
    }
  }]);
}(React.Component);
PanelFooter.displayName = displayNames.PANEL_FOOTER;
PanelFooter.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  actionBtn: PropTypes.element,
  actionBtnSymbol: PropTypes.element,
  thumbnails: PropTypes.element,
  style: PropTypes.object
};
PanelFooter.defaultProps = {
  dataHook: 'panel-footer'
};
export default compose(PanelFooter);